import { activate } from '@/store/module/subscription/mutation/activate.js';
import { cancel } from '@/store/module/subscription/mutation/cancel.js';
import { isSubscribed } from '@/store/module/subscription/mutation/isSubscribed.js';
import { products } from '@/store/module/subscription/mutation/products.js';
import { setSubscription } from '@/store/module/subscription/mutation/setSubscription.js';

export const mutations = {
	activate,
	cancel,
	isSubscribed,
	products,
	setSubscription
};
